<div class="container p-0" #top>
  <form [formGroup]="bookingForm">

    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">business</mat-icon>{{ 'INTERNAL_BOOKING.ORGANIZATION'
      | transloco }}
    </mat-toolbar>

    <mat-form-field appearance="outline">
      <mat-label>{{'INTERNAL_BOOKING.CHOOSE_ORGANIZATION' | transloco }}</mat-label>
      <mat-select (selectionChange)="selectOrganization($event)" formControlName="organization">
        @for (item of allOrgs; track item) {
        <mat-option [value]="item">
          <div class="display-flex">
            <span class="font-weight-bold mr-2">
              {{item.name}}
            </span>
          </div>
        </mat-option>
        }
      </mat-select>
      @if (isLoadingOrganization) {
      <mat-spinner matSuffix color="accent" diameter="20">
      </mat-spinner>
      }
      @if (!isLoadingOrganization) {
      <mat-icon matSuffix>business</mat-icon>
      }
      @if (!bookingForm.controls?.organization?.valid &&
      bookingForm.controls?.organization?.touched) {
      <mat-error>
        {{'INTERNAL_BOOKING.PLEASE_SELECT_ORGANIZATION' | transloco }}
      </mat-error>
      }
    </mat-form-field>

    <app-text-input [formControl]='bookingForm.controls["email"]' [type]="'email'" [label]="'Email'"
      [placeholder]="'PLACEHOLDER.EMAIL' | transloco" [icon]="'email'">
    </app-text-input>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'FORM.PASSENGERS_LABEL' | transloco }}</mat-label>
      <mat-select formControlName="departurePassengers">
        @for (person of persons; track person) {
        <mat-option [value]="person.value">
          {{person.viewValue}}
        </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix>people</mat-icon>
    </mat-form-field>

    <!--DEPARTURE-->
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">flight_takeoff</mat-icon>{{ 'PLACEHOLDER.DEPARTURE' | transloco }}
    </mat-toolbar>

    <!-- Hotel Toggle -->
    <mat-slide-toggle class="mb-4" (change)="toggleHotel($event)" [checked]="showDepHotel"
      [disabled]="!isPassengersSelected">Hotel
    </mat-slide-toggle>

    <!-- Fields when hotel toggle off -->
    @if (!showDepHotel) {
    <div>
      <mat-form-field appearance="outline" (click)="picker.open()">
        <mat-label>{{ 'PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_DEPARTURE_DATE_LABEL' | transloco
          }}</mat-label>
        <input matInput [min]="minDepartureDate" [matDatepicker]="picker" formControlName="flightDepartureDate"
          (dateChange)="getFlightsByDate($event, 'departure');" [disabled]="!isPassengersSelected">
        <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="!isPassengersSelected"></mat-datepicker-toggle>
        <mat-datepicker touchUi #picker [disabled]="!isPassengersSelected"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        @if (isLoadingDeparture) {
        <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
        }
        @if (!isLoadingDeparture) {
        <mat-label>{{ 'FORM.FLIGHT_NUMBER' | transloco }}</mat-label>
        }
        <input matInput type="text" placeholder="{{ 'PLACEHOLDER.SEARCH_FLIGHT' | transloco }}" aria-label="Number"
          formControlName="flightDepartureNumber" [matAutocomplete]="autoDepartures"
          (input)="onDepartureNumberChange($event.target.value)" [disabled]="!isPassengersSelected">
        <mat-autocomplete #autoDepartures="matAutocomplete">
          @for (departFlight of filteredOptionsFlightsDepartures | async; track departFlight) {
          <mat-option [value]="departFlight.flightId" (onSelectionChange)="onDepartureSelect($event)"
            [disabled]="departFlight.locationAndStatus?.flightLegStatus === 'DEL' || departFlight.locationAndStatus?.flightLegStatus === 'Deleted'">
            <div class="display-flex"
              [ngClass]="{'text-decoration-line-through': departFlight.locationAndStatus?.flightLegStatus === 'DEL' || departFlight.locationAndStatus?.flightLegStatus === 'Deleted'}">
              <span class="font-weight-bold mr-2">
                {{departFlight.flightId}}
              </span>
              @if (translate.getActiveLang() === 'sv') {
              <span class="font-weight-light">{{departFlight.arrivalAirportSwedish}}</span>
              }
              @if (translate.getActiveLang() === 'en') {
              <span class="font-weight-light">{{departFlight.arrivalAirportEnglish}}</span>
              }
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
                {{departFlight.departureTime.scheduled | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          }
        </mat-autocomplete>
        @if (isLoadingDeparture) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
        }
        @if (!isLoadingDeparture) {
        <mat-icon matSuffix>flight_takeoff</mat-icon>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.PICKUPTIME' | transloco }}</mat-label>
        <mat-select formControlName="selectedShuttleBusDeparture"
          [disabled]="departureFlight==null || !isPassengersSelected"
          (selectionChange)="setShuttleBus($event.value, 'departure')">
          @if (bookingForm.get('selectedShuttleBusDeparture')?.value; as selectedRoute) {
          <mat-select-trigger>
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{selectedRoute.startDate | date:
                'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (selectedRoute.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(selectedRoute.seats - selectedRoute.passengers)}})</span>
              }
            </div>
          </mat-select-trigger>
          }
          @for (route of plannedShuttleBussesDeparture; track $index) {
          <mat-option [value]="route">
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{route.startDate | date: 'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (route.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(route.seats - route.passengers)}})</span>
              }
            </div>
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline" class="opacity-70">
        <mat-label>{{ 'QUALITY_HOTEL.PARKING_START_DATE' | transloco }}</mat-label>
        <input matInput type="text"
          [value]="$safeNavigationMigration(bookingForm.get('departureStartDateAndTime')?.value) | date:'yyyy-MM-dd HH:mm'"
          readonly [disabled]="!isPassengersSelected" placeholder="YYYY/MM/DD HH:mm">
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
    </div>
    }

    <!-- Fields when hotel toggle on -->
    @if (showDepHotel) {
    <div>
      <!-- split date/time for hotel departure -->
      <mat-form-field appearance="outline" (click)="hotelDepPicker.open()">
        <mat-label>{{ 'FORM.DEPARTURE_DATE' | transloco }}</mat-label>
        <input matInput [matDatepicker]="hotelDepPicker" [min]="minDepartureDate" [value]="hotelDepartureDateOnly"
          (dateChange)="onHotelDateChange($event.value)" [disabled]="!isPassengersSelected" />
        <mat-datepicker-toggle matSuffix [for]="hotelDepPicker"
          [disabled]="!isPassengersSelected"></mat-datepicker-toggle>
        <mat-datepicker touchUi #hotelDepPicker [disabled]="!isPassengersSelected"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
        <input matInput formControlName="hotelDepartureTimeOnly" [matAutocomplete]="hotelTimeAuto"
          (input)="onHotelTimeChange($event.target.value)" [disabled]="!isPassengersSelected" />
        <mat-autocomplete #hotelTimeAuto="matAutocomplete">
          @for (t of filteredHotelTimeOptions | async; track t) {
          <mat-option [value]="t">
            {{t}}
          </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
      <!-- transfer date/time split -->
      <mat-form-field appearance="outline" (click)="transferDepPicker.open()">
        <mat-label>{{ 'FORM.TRANSFER_DATE_LABEL' | transloco }}</mat-label>
        <input matInput [matDatepicker]="transferDepPicker" [min]="minTransferDate" [value]="transferDateOnly"
          (dateChange)="onTransferDateChange($event.value)" [disabled]="!isPassengersSelected" />
        <mat-datepicker-toggle matSuffix [for]="transferDepPicker"
          [disabled]="!isPassengersSelected"></mat-datepicker-toggle>
        <mat-datepicker touchUi #transferDepPicker [disabled]="!isPassengersSelected"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.TRANSFER_TIME_LABEL' | transloco }}</mat-label>
        <input matInput formControlName="transferTimeOnly" [matAutocomplete]="autoTransfer"
          [disabled]="!isPassengersSelected" />
        <mat-autocomplete #autoTransfer="matAutocomplete">
          @for (t of filteredTransferTimeOptions | async; track t) {
          <mat-option [value]="t">
            {{t}}
          </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.PICKUPTIME' | transloco }}</mat-label>
        <mat-select formControlName="selectedShuttleBusDeparture"
          [disabled]="departureFlight==null || !isPassengersSelected"
          (selectionChange)="setShuttleBus($event.value, 'departure')">
          @if (bookingForm.get('selectedShuttleBusDeparture')?.value; as selectedRoute) {
          <mat-select-trigger>
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{selectedRoute.startDate | date:
                'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (selectedRoute.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(selectedRoute.seats - selectedRoute.passengers)}})</span>
              }
            </div>
          </mat-select-trigger>
          }
          @for (route of plannedShuttleBussesDeparture; track $index) {
          <mat-option [value]="route">
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{route.startDate | date: 'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (route.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(route.seats - route.passengers)}})</span>
              }
            </div>
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.TERMINAL_LABEL' | transloco }}</mat-label>
        <mat-select formControlName="departureTerminal" (selectionChange)="onDepartureTerminalSelect($event)"
          [disabled]="!isPassengersSelected">
          @for (terminal of terminals; track terminal) {
          <mat-option [value]="terminal">
            {{terminal.terminalName}}
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>location_on</mat-icon>
      </mat-form-field>
    </div>
    }

    <!--ARRIVAL-->
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">flight_land</mat-icon>{{ 'PLACEHOLDER.ARRIVAL' | transloco }}
    </mat-toolbar>

    <mat-radio-group formControlName="isArrivalByFlight" class="mb-3" (change)="onArrivalTypeChange($event.value)"
      [disabled]="!isPassengersSelected">
      <mat-radio-button value="flight" class="mr-4" [disabled]="!isPassengersSelected">{{'QUALITY_HOTEL.BY_FLIGHT'
        | transloco}}</mat-radio-button>
      <mat-radio-button value="hotel" [disabled]="!isPassengersSelected">{{'QUALITY_HOTEL.BY_TIME' |
        transloco}}</mat-radio-button>
    </mat-radio-group>

    <!-- Fields for by flight -->
    @if (useFlightForArrival) {
    <div>
      <mat-form-field appearance="outline" (click)="picker1.open()">
        <mat-label>{{ 'FORM.ARRIVAL_DATE' | transloco }}</mat-label>
        <input matInput [min]="minArrivalDate" [matDatepicker]="picker1" formControlName="arrivalDate"
          (dateChange)="getFlightsByDate($event, 'arrival');" [disabled]="!isPassengersSelected">
        <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="!isPassengersSelected"></mat-datepicker-toggle>
        <mat-datepicker touchUi #picker1 [disabled]="!isPassengersSelected"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        @if (isLoadingArrival) {
        <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
        }
        @if (!isLoadingArrival) {
        <mat-label>{{ 'FORM.ARRIVAL_FLIGHTNUMBER' | transloco }}</mat-label>
        }
        <input matInput type="text" placeholder="{{ 'PLACEHOLDER.SEARCH_FLIGHT' | transloco }}" aria-label="Number"
          formControlName="flightArrivalNumber" [matAutocomplete]="autoArrivals" [disabled]="!isPassengersSelected">
        <mat-autocomplete #autoArrivals="matAutocomplete">
          @for (arrivalFlight of filteredOptionsFlightsArrivals | async; track arrivalFlight) {
          <mat-option [value]="arrivalFlight.flightId" (onSelectionChange)="onArrivalSelect($event)"
            [disabled]="arrivalFlight.locationAndStatus?.flightLegStatus === 'DEL' || arrivalFlight.locationAndStatus?.flightLegStatus === 'Deleted'">
            <div class="display-flex"
              [ngClass]="{'text-decoration-line-through': arrivalFlight.locationAndStatus?.flightLegStatus === 'DEL' || arrivalFlight.locationAndStatus?.flightLegStatus === 'Deleted'}">
              <span class="font-weight-bold mr-2">
                {{arrivalFlight.flightId}}
              </span>
              @if (translate.getActiveLang() === 'sv') {
              <span class="font-weight-light">{{arrivalFlight.departureAirportSwedish}}</span>
              }
              @if (translate.getActiveLang() === 'en') {
              <span class="font-weight-light">{{arrivalFlight.departureAirportEnglish}}</span>
              }
              <div class="spacer"></div>
              <span class="font-weight-light">{{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
                {{arrivalFlight.arrivalTime.scheduled | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
          }
        </mat-autocomplete>
        @if (isLoadingArrival) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
        }
        @if (!isLoadingArrival) {
        <mat-icon matSuffix>flight_land</mat-icon>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.PICKUPTIME' | transloco }}</mat-label>
        <mat-select formControlName="selectedShuttleBusArrival"
          (selectionChange)="setShuttleBus($event.value, 'arrival')" [disabled]="!isPassengersSelected">
          @if (bookingForm.get('selectedShuttleBusArrival')?.value; as selectedRoute) {
          <mat-select-trigger>
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{selectedRoute.startDate | date:
                'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (selectedRoute.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(selectedRoute.seats - selectedRoute.passengers)}})</span>
              }
            </div>
          </mat-select-trigger>
          }
          @for (route of plannedShuttleBussesArrival; track $index) {
          <mat-option [value]="route">
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{route.startDate | date: 'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (route.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(route.seats - route.passengers)}})</span>
              }
            </div>
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
    </div>
    }

    <!-- Fields for by time -->
    @if (!useFlightForArrival) {
    <div>
      <mat-form-field appearance="outline" (click)="picker2.open()">
        <mat-label>{{ 'FORM.ARRIVAL_DATE' | transloco }}</mat-label>
        <input matInput [min]="minArrivalDate" [matDatepicker]="picker2" formControlName="arrivalDate"
          (dateChange)="fetchArrShuttleBusses();" [disabled]="!isPassengersSelected">
        <mat-datepicker-toggle matSuffix [for]="picker2" [disabled]="!isPassengersSelected"></mat-datepicker-toggle>
        <mat-datepicker touchUi #picker2 [disabled]="!isPassengersSelected"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.TERMINAL_LABEL' | transloco }}</mat-label>
        <mat-select formControlName="arrivalTerminal" (selectionChange)="onArrivalTerminalSelect($event)"
          [disabled]="!isPassengersSelected">
          @for (terminal of terminals; track terminal) {
          <mat-option [value]="terminal">
            {{terminal.terminalName}}
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>location_on</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.PICKUPTIME' | transloco }}</mat-label>
        <mat-select formControlName="selectedShuttleBusArrival"
          (selectionChange)="setShuttleBus($event.value, 'arrival')" [disabled]="!isPassengersSelected">
          @if (bookingForm.get('selectedShuttleBusArrival')?.value; as selectedRoute) {
          <mat-select-trigger>
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{selectedRoute.startDate | date:
                'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (selectedRoute.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(selectedRoute.seats - selectedRoute.passengers)}})</span>
              }
            </div>
          </mat-select-trigger>
          }
          @for (route of plannedShuttleBussesArrival; track $index) {
          <mat-option [value]="route">
            <div class="display-flex">
              <span>{{"PARKIFLY.CLOCK_SHORT" | transloco}}: {{route.startDate | date: 'HH:mm'}}</span>
              <div class="width-5px"></div>
              @if (route.seats != null) {
              <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' |
                transloco}}({{(route.seats - route.passengers)}})</span>
              }
            </div>
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
    </div>
    }

    <mat-slide-toggle class="mt-2 mb-2" formControlName="isArrivalHotel" (change)="toggleHotelUponReturn($event)"
      [disabled]="!isPassengersSelected">{{"PARKIFLY.DATE_AND_FLIGHT_PICKER.HOTEL_ARRIVAL_TOGGLE_LABEL" |
      transloco}}</mat-slide-toggle>

    <!-- Parking end date and time when toggle on -->
    @if (bookingForm.controls.isArrivalHotel.value) {
    <div class="mt-3">
      <!-- parking end date/time split -->
      <mat-form-field appearance="outline" (click)="parkingEndPicker.open()">
        <mat-label>{{ 'FORM.PARKING_END_DATE' | transloco }}</mat-label>
        <input matInput [matDatepicker]="parkingEndPicker" [min]="minParkingEndDate" [value]="parkingEndDateOnly"
          (dateChange)="onParkingDateChange($event.value)" [disabled]="!isPassengersSelected" />
        <mat-datepicker-toggle matSuffix [for]="parkingEndPicker"
          [disabled]="!isPassengersSelected"></mat-datepicker-toggle>
        <mat-datepicker touchUi #parkingEndPicker [disabled]="!isPassengersSelected"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FORM.PARKING_END_TIME' | transloco }}</mat-label>
        <input matInput formControlName="parkingEndTimeOnly" [matAutocomplete]="autoParking"
          [disabled]="!isPassengersSelected" />
        <mat-autocomplete #autoParking="matAutocomplete">
          @for (t of filteredParkingEndTimeOptions | async; track t) {
          <mat-option [value]="t">
            {{t}}
          </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix>schedule</mat-icon>
      </mat-form-field>
    </div>
    }

    @if (!hasAvailableParking) {
    <mat-toolbar color="accent" class="mb-4 mat-elevation-z8 animate__animated animate__bounce">
      Inga lediga platser lediga för vald period
    </mat-toolbar>
    }

    <!-- PARKINGS -->
    <div>
      <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
        <mat-icon class="mr-3">local_parking</mat-icon>{{ 'INTERNAL_BOOKING.PARKINGS' | transloco }}
      </mat-toolbar>

      <mat-form-field appearance="outline">
        @if (!isLoadingParkings) {
        <mat-label>{{'INTERNAL_BOOKING.CHOOSE_PARKING' | transloco}}</mat-label>
        }
        @if (isLoadingParkings) {
        <mat-label>{{'INTERNAL_BOOKING.FETCHING_PARKINGS' | transloco}}</mat-label>
        }
        <!-- <mat-select (selectionChange)="selectParking($event)" formControlName="parking"> -->
        <mat-select formControlName="parking" [disabled]="!isPassengersSelected">
          <mat-select-trigger>
            {{bookingForm.get('parking')?.value?.name}}
          </mat-select-trigger>
          @for (item of parkings; track item) {
          <mat-option class="parking-option" [value]="item" class="width-100">
            <div class="flex-space-between">
              <span class="font-weight-bold mr-2">
                {{item?.name}}
              </span>
              <span class="font-weight-light">
                {{item?.availableParkingSpots}} {{'INTERNAL_BOOKING.SPOTS_AVAILABLE' | transloco}},
                {{item?.totalPrice}} SEK
              </span>
            </div>
          </mat-option>
          }
        </mat-select>
        @if (!isLoadingParkings) {
        <mat-icon matSuffix>local_parking</mat-icon>
        }
        @if (isLoadingParkings) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
        }
        @if (bookingForm.controls.parking.hasError('timeout')) {
        <mat-error>{{ 'INTERNAL_BOOKING.CLICK_REFRESH'
          |
          transloco
          }}</mat-error>
        }
        @if (!bookingForm.controls.parking.hasError('timeout') && !bookingForm.controls.parking.valid &&
        bookingForm.controls.parking.touched) {
        <mat-error>
          {{'INTERNAL_BOOKING.PLEASE_SELECT_PARKING' | transloco }}
        </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- DETAILS -->
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">directions_car</mat-icon>{{ 'FORM.CAR_PERSON' | transloco }}
    </mat-toolbar>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'INTERNAL_BOOKING.BOOKING_NUMBER' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'INTERNAL_BOOKING.ENTER_BOOKING_NUMBER' | transloco }}"
        oninput="this.value = this.value.trim().toUpperCase()" formControlName="bookingNumber"
        [disabled]="!isPassengersSelected">
      <mat-icon matSuffix>confirmation_number</mat-icon>
      @if (!bookingForm.controls.bookingNumber.valid &&
      bookingForm.controls.bookingNumber.touched) {
      <mat-error>
        {{ 'INTERNAL_BOOKING.ENTER_BOOKING_NUMBER' | transloco }}
      </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'FORM.CARID' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'PLACEHOLDER.CARID' | transloco }}"
        oninput="this.value = this.value.trim().toUpperCase()" formControlName="carId"
        [disabled]="!isPassengersSelected">
      <mat-icon matSuffix>directions_car</mat-icon>
      @if (!bookingForm.controls.carId.valid &&
      bookingForm.controls.carId.touched) {
      <mat-error>
        {{ 'ERROR.CARID' | transloco }}
      </mat-error>
      }
    </mat-form-field>

    <app-text-input [formControl]='bookingForm.controls["firstName"]' [label]="'FORM.FIRST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.FIRST_NAME' | transloco" [icon]="'account_box'" [disabled]="!isPassengersSelected">
    </app-text-input>

    <app-text-input [formControl]='bookingForm.controls["lastName"]' [label]="'FORM.LAST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.LAST_NAME' | transloco" [icon]="'account_box'" [disabled]="!isPassengersSelected">
    </app-text-input>

    <app-text-input [formControl]='bookingForm.controls["cellular"]' [type]="'tel'"
      [label]="'FORM.PHONENUMBER' | transloco" [placeholder]="'PLACEHOLDER.PHONENUMBER' | transloco"
      [icon]="'smartphone'" [disabled]="!isPassengersSelected">
    </app-text-input>

    <app-textarea-input [formControl]='bookingForm.controls["comment"]' [label]="'FORM.COMMENT' | transloco"
      [placeholder]="'PLACEHOLDER.OPTIONAL_INFO' | transloco" [disabled]="!isPassengersSelected">
    </app-textarea-input>

    <div class="block-mt-5-mb-75">
      <mat-checkbox formControlName="onlyHandBaggage" (change)="checkBaggage($event)"
        [disabled]="!isPassengersSelected">
        <span class="font-weight-light">{{ 'FORM.ONLY_HANDBAGGAGE' | transloco }}</span>
      </mat-checkbox>
    </div>

    @if(selectedParking?.overbooking && selectedParking?.availableParkingSpots <= 0) { <div
      class="block-mb-75">
      <mat-checkbox formControlName="overrideParking" (change)="checkOverrideParking($event)"
        [disabled]="!isPassengersSelected">
        <span class="font-weight-light">{{ 'PLACEHOLDER.OVER_BOOKING' | transloco }}</span>
      </mat-checkbox>
</div>
}

<div class="block-width-100-mb-75">
  <mat-checkbox formControlName="continueBookingWithPrice" [disabled]="!isBookingFormValid()"
    (change)="checkContinueBookingWithPrice($event)">
    <span class="font-weight-light">{{ 'INTERNAL_BOOKING.CONTINUE_BOOKING_WITH_PRICE' | transloco }}</span>
  </mat-checkbox>
  <div class="margin-left-32px-top-6px">
    @if (!bookingForm.get('continueBookingWithPrice')?.value) {
    <div class="text-95rem-500-475569">
      <span>{{ 'INTERNAL_BOOKING.TOTAL_AMOUNT' | transloco }}: {{ calculatedPrice }} SEK</span>
    </div>
    }

    @if (bookingForm.get('continueBookingWithPrice')?.value) {
    <div class="margin-top-6px">
      <div class="text-95rem-600-1e293b-mb-75">
        <span>{{ 'INTERNAL_BOOKING.TOTAL_AMOUNT' | transloco }}: {{ calculatedPrice }} SEK</span>
      </div>
      <mat-form-field appearance="outline" class="width-100-max-250">
        <mat-label>{{ 'INTERNAL_BOOKING.DESIRED_PRICE' | transloco }}</mat-label>
        <input matInput type="number" formControlName="customPrice" [placeholder]="calculatedPrice.toString()">
        <span matSuffix class="margin-right-8px-font-500">SEK</span>
      </mat-form-field>
    </div>
    }
  </div>
</div>
</form>

<div class="flex-space-between-mt-1-3rem">
  <button mat-raised-button color="warn" type="button" class="mt-2" (click)="resetForm()" class="width-max-content">{{
    'FORM.CLEAR' |
    transloco | uppercase}}
  </button>
  <button mat-raised-button type="button" class="my-2 mt-2 width-max-content" [ngClass]="{ 'success-button': !isLoading && isFormCompleteForSubmission(),
                     'grey-button': !isFormCompleteForSubmission() || isLoading }" (click)="openBottomSheet()"
    [disabled]="isLoading || !isFormCompleteForSubmission()">
    @if (isLoading) {
    <mat-icon class="cursor-pointer">
      <mat-spinner color="accent" diameter="20">
      </mat-spinner>
    </mat-icon>
    }{{ 'FORM.CONTINUE' | transloco | uppercase}}
  </button>
</div>

<app-small-footer></app-small-footer>
</div>